/* eslint-disable max-classes-per-file  */
import { attr, Model, ModelType } from 'redux-orm';

import {
  GET_ALL_SUGGESTED_CONTACTS_SUCCESS,
  GET_PREVIEW_SUGGESTED_CONTACTS_SUCCESS,
  REMOVE_SUGGESTED_CONTACT_SUCCESS,
  ADD_CONTACT_SUCCESS,
} from 'actions';

export interface ISuggestedContact {
  id: string;
  identifier: string;
  from: string;
  totalInteractionCount: number;
  last30DaysCalendarCount: number;
  lastInteractionDate: string;
  contact: {
    firstName: string;
    lastName: string;
    role: string;
    roleType?: string;
    companyName: string;
    phone: string[];
    emails: string[];
  };
}
class Suggested extends Model<typeof Suggested, ISuggestedContact> {
  identifier!: string;

  from!: string;

  totalInteractionCount!: number;

  last30DaysCalendarCount!: number;

  lastInteractionDate!: string;

  contact!: {
    firstName: string;
    lastName: string;
    role: string;
    roleType?: string;
    companyName: string;
    phone: string[];
    emails: string[];
  };

  static reducer(action: any, model: ModelType<Suggested>) {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case GET_ALL_SUGGESTED_CONTACTS_SUCCESS:
      case GET_PREVIEW_SUGGESTED_CONTACTS_SUCCESS:
        action.data.map((d: ISuggestedContact) => model.upsert(d));
        break;
      case REMOVE_SUGGESTED_CONTACT_SUCCESS: {
        const suggestionObj = model.withId(action.id);
        if (suggestionObj) {
          suggestionObj.delete();
        }
        break;
      }
      case ADD_CONTACT_SUCCESS:
        // When a contact is added we remove any suggested contacts with the identifier = the contact email(s)
        action.data.emails.forEach((email: string) => {
          const suggestion = model.withId(email);
          if (suggestion) {
            suggestion.delete();
          }
        });
        break;
    }

    return undefined;
  }

  toString() {
    return this.identifier;
  }

  toViewModel() {
    return {
      ...this.ref,
    };
  }
}

Suggested.modelName = 'SuggestedContact';

Suggested.fields = {
  identifier: attr(),
  from: attr(),
  totalInteractionCount: attr(),
  last30DaysCalendarCount: attr(),
  lastInteractionDate: attr(),
  contact: attr(),
};

Suggested.options = {
  idAttribute: 'identifier',
};

export type SuggestedViewModel = ReturnType<Suggested['toViewModel']>;

export default Suggested;
